<template>
	<div v-if="e" class='popup'>
		<div class="header d-flex align-center">
			<span class="flex-grow-1 pa-2">
				<template v-if="activeItem">
					<v-btn
						icon
						v-on:click="prev"
						small
						v-if="results.length > 1"
					>
						<v-icon
							title="Ankstesnis"
						>
							mdi-chevron-left
						</v-icon>
					</v-btn>
					{{activeItemNumber + 1}} iš {{results.length}}
					<v-btn
						icon
						v-on:click="next"
						small
						v-if="results.length > 1"
					>
						<v-icon
							title="Kitas"
						>
							mdi-chevron-right
						</v-icon>
					</v-btn>
				</template>
				<template v-else>
					Identifikavimo rezultatai
				</template>
			</span>
			<v-btn icon v-on:click="hidePopup">
				<v-icon size="20" title="Uždaryti">mdi-close-circle</v-icon>
			</v-btn>
		</div>
		<div class="pa-2 content">
			<template v-if="loading">
				<v-progress-circular
					indeterminate
					color="primary"
					:size="20"
					width="2"
				></v-progress-circular>
			</template>
			<template v-else-if="results">
				<template v-if="results == 'error'">
					Atsiprašome, įvyko nenumatyta klaida...
				</template>
				<template v-else-if="activeItem">
					Sluoksnis: {{activeItem.layer.service.title}}
					<template v-if="activeItem.item">
						<div v-if="activeItem.item.value" class="body-2">{{activeItem.item.value}}</div>
						<MapLayerAttributes :meta="activeItem.item" class="mt-n2" />
					</template>
					<template v-else-if="activeItem.html">
						<div v-html="activeItem.html"></div>
					</template>
				</template>
				<template v-else>
					Rezultatų nėra
				</template>
			</template>
		</div>
	</div>
</template>

<script>
	import VectorLayer from "ol/layer/Vector";
	import VectorSource from "ol/source/Vector";
	import Feature from "ol/Feature";
	import Point from "ol/geom/Point";
	import Polygon from "ol/geom/Polygon";
	import MultiLineString from "ol/geom/MultiLineString";
	import Style from "ol/style/Style";
	import Icon from "ol/style/Icon";
	import MapLayerAttributes from "../../../components/MapLayerAttributes";

	export default {
		data: function(){
			var data = {
				e: null,
				loading: false,
				results: null,
				activeItemNumber: null,
				activeItem: null
			};
			return data;
		},
		props: {
			map: Object
		},
		created: function(){
			this.$vBus.$on("do-identify", this.showPopup);
		},
		beforeDestroy: function(){
			this.$vBus.$off("do-identify", this.showPopup);
		},
		components: {
			MapLayerAttributes
		},
		methods: {
			showPopup: function(e, map){
				if (map == this.map) { // FIXME! Reikia protingesnio sprendimo! Esmė ta, kad pa'click'inus ant bet kokio map'o iššaukiamas globalus "do-identify"... Ir jei netikrinsime kuris map'as tai iššaukė, galiausiai visuose puslapio map'uose atsidarys popup'ai...
					this.e = e;
				}
			},
			hidePopup: function(){
				this.e = this.activeItem = null;
			},
			doIdentify: function(){
				if (this.e.layers) {
					this.loading = true;
					this.activeItemNumber = this.activeItem = null;
					var defs = [];
					this.e.layers.forEach(function(layer){
						console.log("IDENTIFY ORDER", layer);
						defs.push(this.getLayerIdentifyDef(layer, this.e.coordinates));
					}.bind(this));
					Promise.allSettled(defs).then(function(values){
						var results = [];
						if (values) {
							values.forEach(function(value){
								if (value.status == "fulfilled") {
									if (value.value) {
										if (value.value.html) {
											results.push(value.value);
										} else if (value.value.items) {
											value.value.items.forEach(function(item){
												results.push({
													layer: value.value.layer,
													item: item
												});
											});
										}
									}
								}
							});
						}
						this.results = results;
						this.activeItemNumber = 0;
						this.loading = false;
					}.bind(this), function(){
						this.loading = false;
						this.results = "error";
					}.bind(this));
				}
			},
			getLayerIdentifyDef: function(layer, coordinates){
				var promise = new Promise(function(resolve, reject){
					if (layer.service && layer.service.capabilities && layer.service.capabilities["gisc"]) {
						var capabilities = layer.service.capabilities["gisc"],
							layerType = capabilities.type;
						if (layerType == "AGS" || layerType == "WMS") {
							var layerSourceParams,
								queryParams = {},
								url,
								sublayers;
							if (layerType == "AGS") {
								// http://resources.esri.com/help/9.3/arcgisserver/apis/rest/identify.html
								var mapSize = this.map.getSize(),
									mapViewExtent = this.map.getView().calculateExtent();
								if (layer.getSource().getParams) {
									layerSourceParams = layer.getSource().getParams();
									sublayers = layerSourceParams["layers"];
									if (sublayers) {
										sublayers = sublayers.replace("show:", "");
									}
								}
								url = new URL(location.protocol + "//" + location.host + layer.service.url + "/identify");
								queryParams = {
									f: "json",
									tolerance: 5, // Pikseliai ekrane?
									mapExtent: mapViewExtent.join(","),
									imageDisplay: [mapSize[0], mapSize[1], 96].join(","), // TODO, FIXME: ar trečias elementas masyve visada toks?..
									geometryType: "esriGeometryPoint",
									geometry: JSON.stringify({x: coordinates[0], y: coordinates[1]}),
									sr: this.map.getView().getProjection().getCode().replace("EPSG:", "")
								};
								if (sublayers) {
									queryParams.layers = "top:" + sublayers;
								} else {
									if (layer.service.capabilities["esri"]) {
										sublayers = [];
										if (layer.service.capabilities["esri"].layers) {
											layer.service.capabilities["esri"].layers.forEach(function(l){
												sublayers.push(l.id);
											});
										}
										if (sublayers.length) {
											queryParams.layers = "top:" + sublayers.join(",")
										}
									}
								}
								Object.keys(queryParams).forEach(key => url.searchParams.append(key, queryParams[key]));
								window.fetch(url, {
									method: "GET",
									headers: {
										"Content-Type": "application/json"
									}
								}).then(function(response){
									if (response.status == 200) {
										return response.text();
									} else {
										reject();
									}
								}).then(function(text){
									var items;
									if (text) {
										try {
											var json = JSON.parse(text);
											if (json && json.results) {
												items = json.results;
											}
										} catch(err) {
											// ...
										}
									}
									if (items) {
										resolve({
											layer: layer,
											items: items
										});
									} else {
										reject();
									}
								}.bind(this), function(){
									reject();
								});
							} else if (layerType == "WMS") {
								if (capabilities.featureInfoFormats && capabilities.featureInfoFormats.indexOf("text/html") == -1) {
									queryParams["INFO_FORMAT"] = "text/plain";
								} else {
									queryParams["INFO_FORMAT"] = "text/html";
								}
								if (layer.getSource().getParams) {
									layerSourceParams = layer.getSource().getParams();
									sublayers = layerSourceParams["layers"];
									if (sublayers) {
										queryParams["QUERY_LAYERS"] = sublayers;
									}
								}
								url = layer.getSource().getFeatureInfoUrl(coordinates, this.map.getView().getResolution(), this.map.getView().getProjection().getCode(), queryParams);
								url = decodeURIComponent(url);
								url = url.replace("SERVICE=WMS&", "");
								window.fetch(url, {
									method: "GET"
								}).then(function(response){
									if (response.status == 200) {
										return response.text();
									} else {
										reject();
									}
								}).then(function(text){
									resolve({
										layer: layer,
										html: text
									});
								}.bind(this), function(){
									reject();
								});
							}
						} else {
							reject();
						}
					} else {
						reject();
					}
				}.bind(this));
				return promise;
			},
			prev: function(){
				var selected = this.activeItemNumber - 1;
				if (selected < 0) {
					selected = this.results.length - 1;
				}
				this.activeItemNumber = selected;
			},
			next: function(){
				var selected = this.activeItemNumber + 1;
				if (selected == this.results.length) {
					selected = 0;
				}
				this.activeItemNumber = selected;
			},
			showFeature: function(geometry){
				var g;
				if (geometry.rings) {
					g = new Polygon(geometry.rings);
				} else if (geometry.paths) {
					g = new MultiLineString(geometry.paths);
				} else if (geometry.x && geometry.y) {
					g = new Point([geometry.x, geometry.y]);
				}
				if (g) {
					var feature = new Feature({
						geometry: g
					});
					if (!this.identifyLayer) {
						this.identifyLayer = new VectorLayer({
							source: new VectorSource(),
							zIndex: 1003
						});
						this.map.addLayer(this.identifyLayer);
					}
					this.identifyLayer.getSource().addFeature(feature);
				}
			}
		},
		watch: {
			e: {
				immediate: true,
				handler: function(e){
					if (e) {
						if (this.map.identifyPointLayer) {
							this.map.identifyPointLayer.getSource().clear();
						} else {
							this.map.identifyPointLayer = new VectorLayer({
								style: new Style({
									image: new Icon(({
										src: require("@/assets/identify-marker.png"),
										anchorOrigin: "bottom-left",
										anchor: [0.5, 0],
										anchorXUnits: "fraction",
										anchorYUnits: "fraction"
									}))
								}),
								zIndex: 1004
							});
							this.map.addLayer(this.map.identifyPointLayer);
						}
						var feature = new Feature({
							geometry: new Point(e.coordinates)
						});
						var source = new VectorSource();
						source.addFeature(feature);
						this.map.identifyPointLayer.setSource(source);
						this.doIdentify();
					} else {
						if (this.map.identifyPointLayer) {
							this.map.identifyPointLayer.getSource().clear();
						}
					}
				}
			},
			activeItemNumber: {
				immediate: true,
				handler: function(activeItemNumber){
					if (this.results && this.results[activeItemNumber]) {
						this.activeItem = this.results[activeItemNumber];
					}
				}
			},
			activeItem: {
				immediate: true,
				handler: function(activeItem){
					if (this.identifyLayer) {
						this.identifyLayer.getSource().clear();
					}
					if (activeItem) {
						if (activeItem.item && activeItem.item.geometry) {
							this.showFeature(activeItem.item.geometry);
						}
					}
				}
			}
		}
	};
</script>

<style scoped>
	.popup {
		position: absolute;
		z-index: 1;
		background-color: white;
		border: 1px solid #cccccc;
		width: 500px;
		max-width: 50%;
		right: 8px;
		top: 8px;
		bottom: 8px;
		overflow: auto;
	}
	.header {
		background-color: #eeeeee;
		border-bottom: #dddddd;
	}
	.content {
		overflow: auto;
	}
</style>